<template>
  <div>
    <b-row
      align-v="center"
    >
      <b-col class="p-0">
        <CheckBoxConfiguration
          :controller="PeakPosFitGraphBool"
          :switchprop="true"
        />
      </b-col>
      <b-col
        v-if="PeakPosFitGraphBool.value"
        class="m-0 p-0"
        cols="2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="SinglePeakFitGraphExpanded=!SinglePeakFitGraphExpanded"
        >
          <b-icon
            v-if="SinglePeakFitGraphExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="PeakPosFitGraphBool.value">
      <b-collapse
        v-model="SinglePeakFitGraphExpanded"
        class="ml-5 mb-2 expanded-info p-1 pr-4"
      >
        <TextInputConfiguration
          :controller="CenterPeakPosCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <TextInputConfiguration
          :controller="WindowPeakPosCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <CheckBoxConfiguration
          :controller="ReversePeakPosCtrller"
          :switchprop="true"
        />
        <CheckBoxConfiguration
          :controller="ValleyPeakPosCtrller"
          :switchprop="true"
        />
        <CheckBoxConfiguration
          :controller="StandardAdditionCtrller"
          :switchprop="true"
        />
        <FitSelection
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
        <StatisticalEvaluation
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
      </b-collapse>
    </b-row>
  </div>
</template>

<script>
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import {checkBoxGraphConfCtrller,inputTextConfCtrller} from '@/assets/classes/configuration.js'
import FitSelection from './model/FitSelection'
import StatisticalEvaluation from './StatisticalEvaluation'
import { mapGetters } from 'vuex'

const fitName = 'peakPos'
const rootContextFolder='ReportViewer/Fit/' + fitName

export default {
  name: 'PeakPosFit',
  components:{
    FitSelection,
    StatisticalEvaluation,
    CheckBoxConfiguration,
    TextInputConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data() {
    return {
      fitName,
      elementsConfig:[],
      PeakPosFitGraphBool:new checkBoxGraphConfCtrller(`{0}.${ConfigName.SingleFitDiscreteGraph}`,'Peak Position Fit',false,rootContextFolder+'Enable',true),
      CenterPeakPosCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.center`,'Center','Please give a numerical value','1',(value)=>{return !isNaN(value)&& value!==''}),
      WindowPeakPosCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.window`,'Window','Please give a numerical value greater than zero','2',(value)=>{return !isNaN(value) && value>0}),
      ReversePeakPosCtrller:new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.reverseScan`,'Reverse',false,rootContextFolder+'ReverseSingle'),
      ValleyPeakPosCtrller:new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.valley`,'Valley',false,rootContextFolder+'ValleySingle'),
			StandardAdditionCtrller:new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.StandardAddition`,'Standard Addition',false,rootContextFolder+'StandardAddition'),
			SinglePeakFitGraphExpanded:true
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.elementsConfig = [
      this.PeakPosFitGraphBool,
      this.CenterPeakPosCtrller,
      this.WindowPeakPosCtrller,
      this.ReversePeakPosCtrller,
			this.ValleyPeakPosCtrller,
			this.StandardAdditionCtrller,
    ]
    this.configureStudy()
    this.$watch(
      'PeakPosFitGraphBool.value',
      () => {
        this.verifyConfiguration()
      }
    );
  },
  methods:{
    configureStudy(){
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.PeakPosFitGraphBool.formatKeyValue(this.sectionconfig)
      this.PeakPosFitGraphBool.setParent(this)
      this.verifyConfiguration()
    },
    verifyConfiguration(){
      if(this.PeakPosFitGraphBool.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit])!=='undefined'
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName])!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName]
      }
    }
  }
}
</script>

<style>

</style>
